import { Box, BoxProps } from "@mui/material";

import { AnimatedThreeDots } from "@/Components/Icons/AnimatedThreeDots";

import { MaiteAgentChatBubble } from "./ChatBubbles";

export const PendingAnswerMessageBubble = (props: BoxProps) => (
  <MaiteAgentChatBubble {...props}>
    <Box p={2} display="flex">
      <AnimatedThreeDots />
    </Box>
  </MaiteAgentChatBubble>
);
